{
  "organization": {
    "enabled": "Actief",
    "disabled": "Inaktiv",
    "enable": "Aktivieren",
    "disable": "Deactiveren",
    "name": "Naam",
    "code": "Code",
    "done": "done",
    "cancel": "Afbreken",
    "add": "Toevoegen",
    "create": "Create {{name}}",
    "edit": "Veranderen",
    "save": "Opslaan {{name}}",
    "delete": "Verwijderen",
    "assign": "Manage",
    "active": "Aktiv",
    "status": "Status",
    "details": "Details",
    "messages": {
      "emptyList": "The list is empty"
    },
    "changePassword": {
      "title": "Wachtwoord veranderen",
      "subtitle": "Gebruiker: ",
      "passwordSpecs": "<p>Houd er rekening mee dat het nieuwe wachtwoord aan de volgende vereisten moet voldoen:</p><ul><li>Minimaal 8 tekens</li><li>minstens &eacute;&eacute;n hoofdletter erin</li><li>en ten minste &eacute;&eacute;n nummer</li><li>en ten minste een van de volgende speciale tekens !@#$%^*()_-+{};:.,</li></ul>"
    },
    "userRoles": {
      "b2bcustomergroup": "Customer",
      "b2bapprovergroup": "Approver",
      "b2bmanagergroup": "Manager",
      "b2badmingroup": "Admin",
      "show_order_history": "Show Order History Permission",
      "edit_order_history": "Edit Order History Permission",
      "show_delivery_notes": "Show Delivery Notes Permission",
      "show_invoices_overview": "Show Invoices Overview Permission",
      "show_stock_protection": "Show Stock Protection Permission",
      "show_statistics": "Show Statistics Permission",
      "edit_own_vk": "Edit Own Vk Permission",
      "show_forum": "Show Forum Permission",
      "rio_cart_show": "Only Show Rio Cart Permission",
      "rio_cart_create_update": "Create And Update Cart Permission",
      "rio_cart_order": "Place Cart Order Permission",
      "show_branches": "Show Branches Permission",
      "standard_user": "Ringfoto Standard User",
      "admin_user": "Ringfoto Admin User",
      "shopview_user": "Ringfoto Shop View User",
      "show_bestprice": "Show Bestprice Permission"
    },
    "breadcrumb": "Administratie",
    "notification": {
      "noSufficientPermissions": "Niet voldoende rechten om deze pagina te openen.",
      "notExist": "This item does not exist",
      "disabled": "You cannot edit a disabled item"
    },
    "confirmation": {
      "cancel": "Afbreken",
      "confirm": "OK",
      "disable": "Uitschakelen",
      "delete": "Verwijderen"
    },
    "httpHandlers": {
      "conflict": {
        "budget": "Budget with code {{ code }} already exists.",
        "costCenter": "Cost center with code {{ code }} already exists.",
        "unit": "Organizational unit with uid {{ code }} already exists.",
        "user": "Gebruiker {{ code }} bestaat reeds",
        "userGroup": "User Group with id {{ code }} already exists",
        "permission": "Approval Permission with code {{ code }} already exists.",
        "unknown": "Server validation error."
      }
    }
  }
}
